__turbopack_context__.v({
  "cta": "S6R8rW_cta",
  "destructive": "S6R8rW_destructive",
  "large": "S6R8rW_large",
  "loading": "S6R8rW_loading",
  "medium": "S6R8rW_medium",
  "neutral-filled": "S6R8rW_neutral-filled",
  "neutral-outline": "S6R8rW_neutral-outline",
  "neutral-tonal": "S6R8rW_neutral-tonal",
  "primary": "S6R8rW_primary",
  "slot": "S6R8rW_slot",
  "small": "S6R8rW_small",
  "text": "S6R8rW_text",
  "wide": "S6R8rW_wide",
});
